import { NotificationInline } from '../../../Notification'
import { useDocFlowMappingWidgetMapping } from '../../DocFlow.hooks'
import { DocFlowWidgetForm } from '../../DocFlowWidgetForm'

import { DocFlowMappingWidgetMappingFields } from './DocFlowMappingWidgetMappingFields'

function DocFlowMappingWidgetMapping({ index, name, ...restProps }) {
  const {
    disabled,
    handleAddNotification,
    handleChangeAccuracy,
    handleClearFieldType,
    handleClickNext,
    handleClickPrevious,
    handleDebounceWidgetGetSelectedAreaInfo,
    handleGetMappingSelectedAreaInfo,
    handlePrependNotification,
    handleRemoveAdditionalNotifications,
    handleRemoveNotification,
    hasError,
    initialValues,
    isLoading,
    nextButtonDisabled,
    notifications,
    unvisited,
    widgetDone,
    widgetNotifications,
  } = useDocFlowMappingWidgetMapping({
    index,
    widgetName: name,
  })

  return (
    <DocFlowWidgetForm
      {...restProps}
      actionsProps={{
        disabled: isLoading || nextButtonDisabled,
        isLoading,
      }}
      done={widgetDone && !hasError}
      hasError={hasError}
      index={index}
      initialValues={initialValues}
      name={name}
      unvisited={unvisited}
      onClickPrevious={handleClickPrevious}
      onSubmit={handleClickNext}
    >
      {notifications.map(item => (
        <NotificationInline {...item} key={item.text} />
      ))}

      <DocFlowMappingWidgetMappingFields
        isLoading={isLoading}
        widgetDisabled={disabled}
        widgetNotifications={widgetNotifications}
        onAddNotification={handleAddNotification}
        onChangeAccuracy={handleChangeAccuracy}
        onClearFieldType={handleClearFieldType}
        onDebounceWidgetGetSelectedAreaInfo={
          handleDebounceWidgetGetSelectedAreaInfo
        }
        onGetMappingSelectedAreaInfo={handleGetMappingSelectedAreaInfo}
        onPrependNotification={handlePrependNotification}
        onRemoveAdditionalNotifications={handleRemoveAdditionalNotifications}
        onRemoveNotification={handleRemoveNotification}
      />
    </DocFlowWidgetForm>
  )
}

export default DocFlowMappingWidgetMapping
